import React from 'react'
import Portal from 'components/Portal/Portal'
import { Modal } from 'components/Modal/Modal'
import { Spinner } from '../Loaders/Loaders'
import { DummyFormBlock } from 'components/Forms/Forms'
import ReactMarkdown from 'components/Markdown/Markdown'
import { useHistory } from 'react-router-dom'
import '../MyRecords/MyRecords.scss'

const MiscellaneousOrderRequestModal = ({ show, onDismiss, orderFilings, loading, recordId }) => {
  const history = useHistory()
  return (
    <Portal isOpened={show}>
      <Modal
        title="Request Documents"
        closeModal={onDismiss}
        closeButton
        modalSize="small"
      >
        <div className="amendment-launcher">
          {loading && (
            <div className="flex-center" style={{ padding: '24px 0' }}>
              <Spinner className="page-loader" themeColor="medium-neutral" />
            </div>
          )}
          {!loading && (
            <div className="amendments">
              {orderFilings.length === 0 && (
                <p className="empty">There are no orders available for this record.</p>
              )}
              {orderFilings.map((orderFiling) => (
                <React.Fragment key={orderFiling.FilingTypeId}>
                  <button
                    className="form-block-card"
                    title={orderFiling.FormTitle || orderFiling.FilingTypeName}
                    onClick={() =>
                      history.push(
                        `/forms/new/${orderFiling.FormDefinitionId}?category=miscellaneous&sourceId=${recordId}`
                      )
                    }
                  >
                    <DummyFormBlock label={orderFiling.FormTitle || orderFiling.FilingTypeName} />
                  </button>
                  <ReactMarkdown
                    className="markdown description"
                    source={orderFiling.Description || ''}
                  />
                </React.Fragment>
              ))}
            </div>
          )}
        </div>
      </Modal>
    </Portal>
  )
}

export default MiscellaneousOrderRequestModal
